export default __webpack_public_path__ + "static/media/image6.e8a11290.png";